import { Component, OnInit, ViewChild } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { Apollo } from 'apollo-angular';
import moment from 'moment';
import { ContratistaService } from 'src/app/services/contratista.service';
import { FacturacionService } from 'src/app/services/facturacion.service';
import { LicenciaService } from 'src/app/services/licencia.service';
import { LoginService } from 'src/app/services/login.service';
import { PagoInvitacionComponent } from 'src/app/components/portal-contratista/invitaciones/pago-invitacion/pago-invitacion.component';
import { switchMapTo } from 'rxjs/operators';

@Component({
  selector: 'app-invitaciones',
  templateUrl: './invitaciones.component.html',
  styleUrls: ['./invitaciones.component.scss']
})
export class InvitacionesComponent implements OnInit {
  public dataSource: any
  public tableColumns: String[]
  userLog:any
  invitaciones:any=[]
  facturas:any=[]
  customId:any
  licenciasPagadas:any

  @ViewChild(MatPaginator) paginator?: MatPaginator;
  @ViewChild(MatSort) sort?: MatSort;
  @ViewChild('buttonContainer') buttonContainer: any;
  constructor(
    public dialog: MatDialog, 
    private apollo: Apollo, 
    private facturaService:FacturacionService, 
    private loginService: LoginService,
    private licenciaService:LicenciaService,
    private contratistaService:ContratistaService) {

    this.tableColumns = ['concepto','cliente', 'licencias' , 'base', 'iva','total', 'pagar']
    this.userLog = loginService.getUserData()
   }

  ngOnInit(): void {
    this.getFacturasByContratista()
    this.getContratistaById()
  }

  getFacturasByContratista() {
    this.apollo.watchQuery<any>({
      query: this.facturaService.getFacturasByContratista(),
      variables: {
        "id": this.userLog.contratista.id
      }
    })
      .valueChanges
      .subscribe(({data, loading, errors}) => {
        this.facturas = data.contratista.facturas.filter((factura:any)=>factura.estado == "factura")
        
        if (this.facturas[1]?.customId == undefined) {
          this.customId = 1
        }else{
          this.customId = this.facturas[1].customId + 1
        }
        this.invitaciones = data.contratista.facturas.filter((factura:any)=>factura.estado == "invitacion")
        
        this.dataSource = new MatTableDataSource(this.invitaciones)
        this.dataSource.paginator = this.paginator;     
        this.dataSource.sort = this.sort;
          }
      )
  }


  payFactura(){
   
    
    /* fetch('https://frosty-roentgen.54-154-127-160.plesk.page/tpv/index.php', { mode: 'no-cors'}).then(res => res).then(data => console.log(data)) */
    
    
    /* this.updateFacturaById(idFactura)
    this.updateContratistaById(numLicencias)
    for (let i = 0; i < numLicencias; i++) {
      this.addLicencias(idFactura, idCliente)
      
    }
    setTimeout(() => {
      location.reload()
    }, 1500); */
  }

  

  updateFacturaById(id:any){
    this.apollo.mutate({
      mutation: this.facturaService.updateFactura(),
      variables: {
        "input": {
          "where": {
            "id": id,
          },
          "data": {
            "estado": "factura",
            "identificadorXT": "XT",
            "customId": this.customId,
            "numeroFactura": "XT"+this.customId,
            "fechaPago": moment(new Date())
          }
        }    
      }
    })
      .subscribe(({data, errors}) => {
        console.log("update", data, errors)
      }, (error) => {
        console.log('error',error)
      })
  }

  addLicencias(idFactura:any, idCliente:any){
    console.log(idFactura);
    
    this.apollo.mutate<any>({
      mutation: this.licenciaService.addLicencia(),
      variables: {
        "input": {
          "data": {
            "numFactura": "XT"+this.customId,
            "contratista": this.userLog.contratista.id,
            "facturas": idFactura,
            "cliente": idCliente
          }
        }
      }
    }).subscribe(({data, errors}) => {
      
        console.log('OK', data)
        
      
      }, (error) => {
      console.log('Error al lanzar la query', error);
    })
  }

  updateContratistaById(numLicencias:any) {
    this.licenciasPagadas = this.licenciasPagadas + numLicencias
    this.apollo.mutate({
      mutation: this.contratistaService.updateContratista(),
      variables: {
        "input": {
          "where": {
            "id": this.userLog.contratista.id
          },
          "data": {
            "licenciasPagadas": this.licenciasPagadas
          }
        }
      }
    })
      .subscribe(({ data, errors }) => {
        console.log("EDITADO", data, errors)
      }, (error) => {
        console.log('aaaaa', error)
      })
  }

  getContratistaById(){
    this.apollo.watchQuery<any>({
      query: this.contratistaService.getContratistaById(),
  
      variables: {
        "id": this.userLog.contratista.id
      }
    })
      .valueChanges
      .subscribe(({data, loading, errors}) => {
        this.licenciasPagadas = data.contratista.licenciasPagadas
      })
  }
   openDialog(id:any) {
    this.dialog.open(PagoInvitacionComponent)
    
    this.facturaService.setIdFactura(id)
    
    }

}
